import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useTechnologicalTransferCreate } from '@/module/Author/TechnologicalTransfer/model/TechnologicalTransferQuery';
import {
  TechnologicalTransferSchema,
  defaultTechnologicalTransferValues,
  technologicalTransferSchema,
} from '@/module/Author/TechnologicalTransfer/model/TechnologicalTransferSchema';

import { useAppNotification } from '@feature/utils';

import { TechnologicalTransferForm } from './TechnologicalTransferForm';

export function TechnologicalTransferCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useTechnologicalTransferCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: TechnologicalTransferSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newTechnologicalTransfer => {
        notification.success();
        navigate({
          to: '/author/technological-transfer/$technologicalTransferId',
          params: { technologicalTransferId: String(newTechnologicalTransfer.id) },
        });
      },
    });
  };

  return (
    <TechnologicalTransferForm
      title={t('technologicalTransfers.form.title.create')}
      schema={technologicalTransferSchema}
      defaultValues={defaultTechnologicalTransferValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
